import React from 'react';
import LandingPageCategoryEditor from '../../../components/landing-page-category-editor';

const LandingPageCategoryEditorRoute = (props) => (
  <LandingPageCategoryEditor {...props}/>
);

export default LandingPageCategoryEditorRoute;
